<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="640">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text v-bind="attrs" v-on="on">
          Upload & Convert Games
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Upload & Convert Games
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <span v-if="session">Working with {{ session.name }}</span>
            </v-col>
          </v-row>
          <v-form ref="frmRegister">
            <v-file-input v-model="files" 
              placeholder="Upload games" 
              label="File input" 
              multiple
              accept=".xlsx,.txt,.xls"
              prepend-icon="mdi-paperclip">
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-progress-linear v-if="uploadedPercent" :value="uploadedPercent" striped height="10"></v-progress-linear>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="uploadFiles">
            Upload & Convert
          </v-btn>
          <v-btn color="error" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
  export default {
    data: () => ({
      files: [],
      dialog: false,
      uploadedPercent: 0
    }),
    computed: {
      ...mapState('session', ['session']),
      ...mapState('auth', ['auth']),
      ...mapState('targettimes', ['targettimes']),
      ...mapState('alfakodos', ['alfakodos']),
    },
    methods: {
      uploadFiles() {
        if (this.files.length >= 1) {
          var data = new FormData()
          for (let file of this.files) {
            data.append("files[]", file, file.name);
          }
          if(this.session) {
            data.append("client", this.session.id)
          } else {
            this.$toastr.e('You must select a Client.')
            return false
          }
          var that = this
          this.$axios({
            method: 'post',
            url: 'files',
            data: data,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function (event) {
              that.uploadedPercent = (event.loaded / event.total) * 100
            }
          }).then(res => {
            if(res.data.message) {
              this.$toastr.e(res.data.message, res.data.clientName)
            } else {
                this.$toastr.s(res.data.length + " games uploaded for " + this.$store.getters['session/clientName'] + " converted and ready.")
            }
            this.files = []
            this.uploadedPercent = 0
            this.dialog = false
            this.$store.dispatch('reload')
            // this.$router.go()
          }).catch(err => {
            this.$toastr.e(err)
            this.uploadedPercent = 0
            this.$store.dispatch('reload')
          })
        } else {
          this.$toastr.e('You must select a file.')
        }
      }
    }
  }
</script>